import React from 'react';
import { updateAuction, getAuction } from '../../../../../../models/auctions';
import swal from 'sweetalert';
import i18n from '../../../../../../i18n';
import { Spinner } from 'react-bootstrap';
import { Plus, Trash2 } from 'lucide-react';

export class EnquiriesTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auctionId: props.auctionId,
      input: {},
      errors: {},
      enquiries: [{ label: '', value: '', label_ar: '', value_ar: '' }],
      details: [{ label: '', value: '', label_ar: '', value_ar: '' }],
      is_loading: false,
    };
    this.handleEnquirySubmit = this.handleEnquirySubmit.bind(this);
    this.handleDetailsSubmit = this.handleDetailsSubmit.bind(this);
    this.appendData = this.appendData.bind(this);
    this.removeEnquiryData = this.removeEnquiryData.bind(this);
    this.setEnquiryJson = this.setEnquiryJson.bind(this);
    this.appendDetailsData = this.appendDetailsData.bind(this);
    this.removeDetailsData = this.removeDetailsData.bind(this);
    this.setDetailsJson = this.setDetailsJson.bind(this);
  }

  componentDidMount() { this.loadAuction(); }

  async loadAuction() {
    this.setState({ is_loading: true });
    const response = await getAuction(this.state.auctionId);
    let auction = response.data;
    if (auction) {
      if (auction.enquiry && auction.enquiry.length) this.setState({ enquiries: auction.enquiry });
      if (auction.details && auction.details.length) this.setState({ details: auction.details });
      this.setState({ is_loading: false });
    }
  }

  handleEnquirySubmit = async (event) => {
    event.preventDefault();
    try {
      let payload = this.state.input;
      payload.is_enquiry_update = true;
      payload.enquiries = this.state.enquiries;
      const response = await updateAuction(payload, this.state.auctionId);
      if (response && response.data && response.data.id) {
        swal(i18n.t('success'), response.message, 'success', { buttons: false, timer: 2000 })
          .catch((r) => swal('Failed', r.message, 'error'));
      } else {
        let msg = 'Not found!!!';
        let msgs = response.message;
        for (const key in msgs) { if (Object.hasOwnProperty.call(msgs, key)) msg += '\n' + msgs[key]; }
        swal('Failed', msg, 'error');
      }
    } catch (err) { console.log(err); }
  };

  handleDetailsSubmit = async (event) => {
    event.preventDefault();
    try {
      let payload = this.state.input;
      payload.is_details_update = true;
      payload.details = this.state.details;
      const response = await updateAuction(payload, this.state.auctionId);
      if (response && response.data && response.data.id) {
        swal(i18n.t('success'), response.message, 'success', { buttons: false, timer: 2000 })
          .catch((r) => swal('Failed', r.message, 'error'));
      } else {
        let msg = 'Not found!!!';
        let msgs = response.message;
        for (const key in msgs) { if (Object.hasOwnProperty.call(msgs, key)) msg += '\n' + msgs[key]; }
        swal('Failed', msg, 'error');
      }
    } catch (err) { console.log(err); }
  };

  appendData(e) { e.preventDefault(); let eq = this.state.enquiries || []; eq.push({ label: '', value: '' }); this.setState({ enquiries: eq }); }
  removeEnquiryData(key) { let eq = this.state.enquiries; delete eq[key]; this.setState({ enquiries: eq }); }
  setEnquiryJson(key, event, i) { let eq = this.state.enquiries; eq[i][key] = event.target.value; this.setState({ enquiries: eq }); }

  appendDetailsData(e) { e.preventDefault(); let d = this.state.details || []; d.push({ label: '', value: '' }); this.setState({ details: d }); }
  removeDetailsData(key) { let d = this.state.details; delete d[key]; this.setState({ details: d }); }
  setDetailsJson(key, event, i) { let d = this.state.details; d[i][key] = event.target.value; this.setState({ details: d }); }

  renderKeyValueSection(title, items, setFn, removeFn, appendFn, submitFn, submitLabel) {
    return (
      <form onSubmit={submitFn}>
        <div className="form-section">
          <div className="section-header">
            <h2>{title}</h2>
            <button type="button" className="button1 button1-secondary" onClick={appendFn}>
              <Plus size={18} /> {i18n.t('add_new')}
            </button>
          </div>

          {this.state.is_loading && (
            <div style={{ textAlign: 'center', padding: '1rem' }}><Spinner animation="border" /></div>
          )}

          {items && items.length > 0 && items.map((item, i) => (
            <div key={i} className="enquiry-item">
              <div className="form-row">
                <div className="form-field">
                  <label>Label</label>
                  <input type="text" placeholder="Label" value={item.label || ''}
                    onChange={(e) => setFn('label', e, i)} />
                </div>
                <div className="form-field">
                  <label>Value</label>
                  <input type="text" placeholder="Value" value={item.value || ''}
                    onChange={(e) => setFn('value', e, i)} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Label ({i18n.t('arabic')})</label>
                  <input type="text" placeholder="Label (Arabic)" dir="rtl" value={item.label_ar || ''}
                    onChange={(e) => setFn('label_ar', e, i)} />
                </div>
                <div className="form-field">
                  <label>Value ({i18n.t('arabic')})</label>
                  <input type="text" placeholder="Value (Arabic)" dir="rtl" value={item.value_ar || ''}
                    onChange={(e) => setFn('value_ar', e, i)} />
                </div>
              </div>
              {i > 0 && (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <button type="button" className="button1 button1-danger" onClick={() => removeFn(i)}>
                    <Trash2 size={16} /> {i18n.t('remove')}
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="action-buttons-l2 border-top-light">
          <button type="submit" className="button1 button1-primary">{submitLabel}</button>
        </div>
      </form>
    );
  }

  render() {
    return (
      <div>
        {this.renderKeyValueSection(
          i18n.t('enquiry'), this.state.enquiries,
          this.setEnquiryJson, this.removeEnquiryData, this.appendData,
          this.handleEnquirySubmit, 'Update Enquiries'
        )}
        <div style={{ margin: '24px 0', borderTop: '1px solid #e5e7eb' }}></div>
        {this.renderKeyValueSection(
          i18n.t('details'), this.state.details,
          this.setDetailsJson, this.removeDetailsData, this.appendDetailsData,
          this.handleDetailsSubmit, 'Update Details'
        )}
      </div>
    );
  }
}